module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web27.29e61638.jpg";